import React, { useState, useEffect, useRef } from 'react';
import styles from './HomePage.module.css';
import Nav from '../../components/Nav/Nav';
import Divider from '../../components/Divider/Divider';
import GameArea from './GameArea/GameArea';

const HomePage = () => {

  return (
    <div className={styles.body}>
      <Nav />
      <div className={styles.main}>
        <GameArea />
        <Divider />
      </div>
    </div>
  );
};

export default HomePage;